import { CoreScoreNames } from "../../../enum/score-name-cube.enum";

export interface GetScoreAveragesRequestParamsDto {
    endDate: string;
    score: CoreScoreNames;
}